import api from '../../../auth/apiClient';
import { UPKEEP_MAP_API } from '../apiConfig';
import { UpkeepMapRaw, CoaOption, ActivityOption } from '../types';

export class UpkeepMapApiService {
    static async getCoaList(companyId: number): Promise<CoaOption[]> {
        const res = await api.get(UPKEEP_MAP_API.COA_LIST, { params: { company_id: companyId } });
        return res.data?.data ?? [];
    }

    static async getActivityList(coaId: number): Promise<ActivityOption[]> {
        const res = await api.get(UPKEEP_MAP_API.ACTIVITY_LIST, { params: { coa_id: coaId } });
        return res.data?.data ?? [];
    }

    static async getBlockReport(params: {
        activity_id: number;
        budget_year: string;
        company_id: number;
        revision: number;
        estate_id?: number;
        budget_month?: string;
    }): Promise<UpkeepMapRaw[]> {
        const res = await api.get(UPKEEP_MAP_API.BLOCK_REPORT, { params });
        return res.data?.data ?? [];
    }
}
